export const questionPairs = [
  ["Szeretem, ha valaki kedves szavakkal fejezi ki szeretetét felém.", "Szeretem, ha valaki gesztusokkal, például egy öleléssel fejezi ki szeretetét."],
  ["Fontos, hogy szívességekkel lepjenek meg.", "Fontos, hogy néha csak kettesben töltsük az időt."],
  ["Jól esik, ha ajándékot kapok.", "Jól esik, ha társam segít elintézni dolgaimat."],
  ["Több öröm számomra a közös sétákban rejlik.", "Több öröm számomra egy váratlan ölelésben rejlik."],
  ["Értékelem a bátorító szavakat.", "Értékelem, amikor segítenek, ha elfáradtam."],
  ["Boldoggá tesz, ha elismerik teljesítményemet.", "Boldoggá tesz, ha figyelmesek velem."],
  ["Fontos, ha valaki meghallgat és biztat.", "Fontos, ha megajándékoznak valami kis aprósággal."],
  ["Jól esik, ha együtt nevetünk.", "Jól esik, ha megdicsérnek valamivel kapcsolatban."],
  ["Jobban kötődöm ajándékokon keresztül.", "Jobban kötődöm közös élményeken keresztül."],
  ["Szeretem, ha megölelnek.", "Szeretem, ha bókot kapok."],
  ["Fontos, hogy gyakran mondják: szeretnek.", "Fontos, hogy gyakran odabújva beszélgethessünk."],
  ["Örömet ad, ha segítenek a mindennapokban.", "Örömet ad, ha őszintén elmondják, hogy fontos vagyok."],
  ["Jó érzés, ha támogatnak szavakkal.", "Jó érzés, ha valamilyen különleges tervet szervezünk együtt."],
  ["Fontos, hogy ajándékkal fejezzem ki szeretetemet.", "Fontos, hogy törődjek, figyelek a másikra."],
  ["Számít, ha segítenek a nehéz helyzetekben.", "Számít, ha megérintenek, megsimogatnak."],
  ["Szeretem hallani, hogy büszkék rám.", "Szeretem átélni az együtt töltött különleges pillanatokat."],
  ["Közelebb érzem magam, ha dicséretet kapok.", "Közelebb érzem magam, ha közösen elkészítünk valamit."],
  ["Jól esik, ha apró figyelmességeket kapok.", "Jól esik, ha közösen utazunk, kirándulunk."],
  ["Boldoggá tesz a dicséret.", "Boldoggá tesz a támogatás cselekedetekben."],
  ["Fontos az ölelés.", "Fontos az elismerő tekintet."],
  ["Örülök, hogyha valaki időt szán rám.", "Örülök, ha valaki lenyűgöz saját készítésű meglepetéssel."],
  ["Szeretem, ha minden feladatot együtt végzünk.", "Szeretem, ha minden nap hallom, hogy fontos vagyok."],
  ["Fontos, hogy kimutassák, számítok.", "Fontos, hogy meghallgassanak, amikor beszélek."],
  ["Jelentőséggel bír számomra, ha valaki velem foglalkozik.", "Jelentőséggel bír, ha kedves szavakat mondanak nekem."],
  ["Örülök, ha igyekeznek segíteni nekem.", "Örülök, ha együtt töltjük az időt csendben."],
  ["Jobban örülök egy kedves szó miatt.", "Jobban örülök egy közös tevékenység miatt."],
  ["Többet jelent egy kézírásos levél.", "Többet jelent egy kézfogás vagy érintés."],
  ["Szeretem, amikor segít elintézni dolgaimat.", "Szeretem, amikor őszintén elmondja, szeret."],
  ["Jobban értékelem az együtt töltött időt.", "Jobban értékelem a kedves szavakat."],
  ["Különlegesnek érzem magam, ha megérintenek.", "Különlegesnek érzem magam, ha különleges ajándékot kapok."]
];

export const loveLangNames = [
  'Elismerő szavak',      // A
  'Minőségi idő',         // B  
  'Ajándékozás',          // C
  'Szívességek',          // D
  'Testi érintés'         // E
];

export const loveLangKey = [
  ['A','E'], ['D','B'], ['C','D'], ['B','E'], ['A','D'], 
  ['A','B'], ['A','C'], ['B','A'], ['C','B'], ['E','A'],
  ['A','E'], ['D','A'], ['A','B'], ['C','D'], ['D','B'], 
  ['A','B'], ['A','B'], ['C','B'], ['A','D'], ['E','A'],
  ['B','C'], ['D','A'], ['A','B'], ['B','A'], ['D','B'], 
  ['A','B'], ['A','E'], ['D','A'], ['B','B'], ['E','C']
];